export default "__VITE_PUBLIC_ASSET__b7c54492__"